export default "__VITE_ASSET__BHvZzh50__"